<template>
  <div :class="success ?  'OneDrive' : 'OneDrive__error' ">
    <div class="OneDrive__header">
      <span>Result: Upload to OneDrive</span>
      <v-btn icon @click="extend = !extend"><v-icon> {{ extend ? 'mdi-chevron-up' : 'mdi-chevron-down' }} </v-icon></v-btn>
    </div>
    <div v-if="extend && success">
      <div v-if="isValidJson" class="OneDrive__body">
        <div>
          <p v-if="!outputObject.shareUrl"><span style="font-weight: bold">File ID: </span>{{ outputObject.fileId }}</p>
          <p v-if="outputObject.shareUrl"><span style="font-weight: bold">File ID: </span><a :href="outputObject.shareUrl">{{ outputObject.fileId }}</a></p>
        </div>
        <json-viewer
            :expand-depth=0
            :value="outputObject"
            style="white-space: pre-line; border-radius: 15px; width: 100%"
        ></json-viewer>
      </div>
      <div v-if="!isValidJson && typeof outputObject !== 'string'" style="padding: 10px">
        <v-progress-circular
            :size="20"
            :width="1"
            color="primary"
            indeterminate
        />
      </div>
      <div v-if="!isValidJson && typeof outputObject === 'string'" class="OneDrive__body">
        {{ outputObject }}
      </div>
    </div>
    <div v-if="extend && !success">
      <div class="OneDrive__error_body">
        <span style="font-weight: bold;">Error: </span> {{ outputObject }}
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-json-viewer/style.css';
import { helpers } from '@/mixins/helpers';
import VueLoaders from 'vue-loaders';

import JsonViewer from 'vue-json-viewer';
import Vue from "vue";

Vue.use(VueLoaders);

export default {
  name: 'one-drive-upload-action-output',
  components: { JsonViewer },
  props: {
    output: {},
    name: {},
    success: {},
  },
  mixins: [helpers],
  data() {
    return {
      extend: false,
    };
  },
  computed: {
    outputObject() {
      if(!this.isValidJson) {
        return this.output;
      }
      return typeof this.output !== 'string' ? this.output : JSON.parse(this.output)
    },
    isValidJson() {
      try {
        if(typeof this.output !== 'string') {
          return true;
        }
        JSON.parse(this.output);
        return true
      } catch (e) {
        return false;
      }
    }
  },
  methods: {},
};
</script>

<style scoped lang="scss">
@import '../index';
</style>
